import { c as _c } from "react/compiler-runtime";
import { Form, Formik, useFormikContext } from 'formik';
import { CodeSnippetWithForm } from '../../../../common/CodeSnippet';
import { Div } from '../../../../common/helpers/StyledUtils';
import { OutpostGetStartedContext, OutpostGetStartedStepProps } from '../GetStartedView';
import { entriesToMetadata, getCreateTenantInitialValues, noopOutpostFormSubmit, TenantCreateFields, TenantFormValues } from '../../utils/outpostForms';
import { buildCreateTenantExamples, getOutpostSnippetLanguage, useOutpostSnippetMaskableValue } from '../../utils/outpostSnippets';
import CreatedResourceData from './CreatedResourceData';
import Text from '../../../../common/base/Text';
import styled from 'styled-components';
import { capitalizeFirstLetter } from '../../../../../utils';
const DEFAULT_TENANT_ID = 'my-tenant-id';
const TENANT_ID_PLACEHOLDER = 'my-tenant-id';
const StyledHint = styled(Div)`
  position: absolute;
  right: 0;
  transform: translateX(95%);
  top: -4px;
  z-index: 2;

  svg {
    fill: ${({
  theme
}) => theme.colors.on.neutral.primary};
  }

  ${Text} {
    width: 160px;
    transform: rotate(-8deg);
  }
`;
const CreateTenantForm: React.FC<{
  context: OutpostGetStartedContext;
}> = t0 => {
  const $ = _c(26);
  const {
    context: t1
  } = t0;
  const {
    active_language,
    tenant
  } = t1;
  const {
    values
  } = useFormikContext();
  let t2;
  if ($[0] !== active_language || $[1] !== values.metadata_entries) {
    const tenant_metadata = entriesToMetadata(values.metadata_entries);
    t2 = buildCreateTenantExamples({
      tenant_id: TENANT_ID_PLACEHOLDER,
      metadata: Object.keys(tenant_metadata).length > 0 ? tenant_metadata : undefined
    })[active_language] ?? "";
    $[0] = active_language;
    $[1] = values.metadata_entries;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const example = t2;
  let t3;
  if ($[3] !== active_language) {
    t3 = getOutpostSnippetLanguage(active_language);
    $[3] = active_language;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const snippet_language = t3;
  const maskable_value = useOutpostSnippetMaskableValue();
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      position: "relative"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = values.tenant_id || TENANT_ID_PLACEHOLDER;
  let t6;
  if ($[6] !== t5) {
    t6 = [{
      placeholder: TENANT_ID_PLACEHOLDER,
      value: t5
    }];
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = tenant?.id;
  let t8;
  if ($[8] !== t7) {
    t8 = <TenantCreateFields current_tenant_id={t7} />;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== example || $[11] !== maskable_value || $[12] !== snippet_language || $[13] !== t6 || $[14] !== t8) {
    t9 = <div style={t4}><CodeSnippetWithForm code={example} language={snippet_language} section_title="Create a tenant in Outpost" default_open={true} underlined_values={t6} maskable_value={maskable_value}>{t8}</CodeSnippetWithForm></div>;
    $[10] = example;
    $[11] = maskable_value;
    $[12] = snippet_language;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      t: 6
    };
    t11 = {
      align: "center",
      gap: 2
    };
    $[16] = t10;
    $[17] = t11;
  } else {
    t10 = $[16];
    t11 = $[17];
  }
  let t12;
  if ($[18] !== active_language) {
    t12 = active_language === "http" ? "Copy cURL request and send the API call via your terminal or HTTP client..." : `Run ${capitalizeFirstLetter(active_language)} command to create the tenant...`;
    $[18] = active_language;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== tenant) {
    t13 = <Div m={t10} flex={t11}><CreatedResourceData waiting_label={t12} status_label="Tenant created" created_resource={tenant} /></Div>;
    $[20] = t12;
    $[21] = tenant;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13 || $[24] !== t9) {
    t14 = <Form>{t9}{t13}</Form>;
    $[23] = t13;
    $[24] = t9;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
};
const CreateTenant: React.FC<OutpostGetStartedStepProps> = t0 => {
  const $ = _c(7);
  const {
    context
  } = t0;
  const t1 = context.tenant?.id || DEFAULT_TENANT_ID;
  let t2;
  if ($[0] !== t1) {
    t2 = getCreateTenantInitialValues(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== context) {
    t3 = <CreateTenantForm context={context} />;
    $[2] = context;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <Formik initialValues={t2} onSubmit={noopOutpostFormSubmit}>{t3}</Formik>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default CreateTenant;